<script>
  export let color;
  export let setColor = (col) => {
    color = col;
  };
</script>

<button
  on:click={setColor}
  class="button-color"
  style="background-color: {color};"
></button>

<style>
  .button-color {
    width: 30px;
    height: 30px;
    border-radius: 5px;
    border: none;
  }
</style>
